export enum StrategyActionType {
  CreateStrategy = 'strategies/CreateStrategy',
  CreateStrategySuccess = 'strategies/CreateStrategySuccess',
  CreateStrategyFailure = 'strategies/CreateStrategyFailure',
  DuplicateStrategy = 'strategies/DuplicateStrategy',
  DuplicateStrategySuccess = 'strategies/DuplicateStrategySuccess',
  DuplicateStrategyFailure = 'strategies/DuplicateStrategyFailure',
}
